import { Injectable } from '@angular/core';
import { Events, LoadingController, Platform } from 'ionic-angular';
import { Globals } from '../../globals';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import * as firebase from 'firebase';

@Injectable()
export class QRServices {

  public firestore;

  constructor(public events: Events,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    public translate: TranslateService,
    public globals: Globals,
    public http: HttpClient) {
    this.firestore = firebase.firestore();
  }

  async generateMenuCartaGR(element_uid, type) {

    this.globals.GAtrackView('Cartas/Menús', 'Cartas/Menús - QR', this.globals.restaurant.email, 'View', 'QR Cartas/Menús', 'Cartas/Menús', '');
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-generando-qr')
    });
    loadingPopup.present();
    //logo
    var logo_format;
    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //http post
    this.http.post(this.globals.api_path + 'menu_carta/qr_v2',
      {
        public_key: this.globals.public_key,
        logo: logo_format,
        lang: this.globals.restaurant.lang,
        type: type,
        element_uid: element_uid
      }, {})
      .subscribe(res => {
        loadingPopup.dismiss();
        window.open(String(res['file']));
      }, error => {
        loadingPopup.dismiss();
      });
  }

  async generateMenuCartaListQr() {
    this.globals.GAtrackView('Cartas/Menús', 'Cartas/Menús - QR', this.globals.restaurant.email, 'View', 'QR Cartas/Menús', 'Cartas/Menús', '');
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-generando-qr')
    });
    loadingPopup.present();
    //logo
    var logo_format;
    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //http post
    this.http.post(this.globals.api_path + 'menu_carta/qr_list',
      {
        public_key: this.globals.public_key,
        logo: logo_format,
        lang: this.globals.restaurant.lang,
      }, {})
      .subscribe(res => {
        loadingPopup.dismiss();
        window.open(String(res['file']));
      }, error => {
        loadingPopup.dismiss();
      });
  }

  async generateTakeawayQR() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-generando-qr')
    });
    loadingPopup.present();
    //logo
    var logo_format;
    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //http post
    this.http.post(this.globals.api_path + 'takeaway/qr',
      {
        public_key: this.globals.public_key,
        logo: logo_format,
        lang: this.globals.restaurant.lang,
      }, {})
      .subscribe(res => {
        loadingPopup.dismiss();
        window.open(String(res['file']));
      }, error => {
        loadingPopup.dismiss();
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/services/qrServices.ts